// Import Packages
import { Component } from 'react';
import  {Swiper, SwiperSlide} from 'swiper/react';

// Assets
import contract from '../../assets/contract.svg';
import deliver from '../../assets/deliver.svg';
import implement from '../../assets/implement.svg';
import prepare from '../../assets/prepare.svg';
import tata from '../../assets/ratantata.svg';

// Import Swiper Styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Import Required Modules
import { Pagination, Navigation } from "swiper"; 

export default class AboutUs extends Component {

    constructor(props) {

        super(props);

        this.state = {
            slideCnt: 3 
        }
    }

    stepblock(img,title,steptitle) {

        return (
            <div className='AboutUs_StepBlock'>
                <img className='AboutUs_StepImg' src={img}/>
                <div className='AboutUs_StepTitle'>{title}</div>
                <div className='AboutUs_StepCount'>{steptitle}</div>
            </div>
        );
    }

    clientsCard() {

        return(
            <div className='AboutUs_ClientsCard'>
                <img className='AboutUs_ClientImg' src={tata}/>
                <div className='AboutUs_ClientDesc'>
                    It was exciting to work with them, they execution is in time with proper finished development.
                    It was exciting to work with them, they execution is in time with proper finished development
                </div>
                <div className='AboutUs_ClientName'>Ratan Tata</div>
            </div>
        );
    }

    windowSize = () => {

        let width = document.body.clientWidth;
        let slideCnt = this.state.slideCnt;

        if(width <= 480) {
            
            if(slideCnt !== 1) {
                this.setState({slideCnt: 1})
            }
        
        } else if(width > 480 && width <= 770) {
            
            if(slideCnt !== 2) {
                this.setState({slideCnt: 2});
            }

        } else if(width > 770) { 
            if(slideCnt !== 3) {
                this.setState({slideCnt: 3});
            }
        }
    }

    render() {

        window.addEventListener("resize",this.windowSize)
        //console.log("Slide",this.state.slideCnt)
        return (
            <div className='AboutUs'>
                <div className='AboutUs_Work'>
                    <div className='AboutUs_TitleBlock'>
                        <div className='AboutUs_Title1'>
                            How We Work!!
                        </div>
                        <div className='AboutUs_Title2'>
                            Pushing the Boundries of Whats Possible
                        </div>
                    </div>
                    <div className='AboutUs_Steps'>
                        {this.stepblock(contract,"Signing Of Contract","Step 01")}
                        {this.stepblock(prepare,"Preparation Of Plan","Step 02")}
                        {this.stepblock(implement,"Implementation Of Works","Step 03")}
                        {this.stepblock(deliver,"Delivering Project","Step 04")}
                    </div>
                </div>
                <div className='AboutUs_Testamonial'>
                    <div className='AboutUs_TestamonialTitle'>What Our Clients Says ! ! ! </div>
                    <Swiper
                      slidesPerView={this.state.slideCnt}
                      spaceBetween={30}
                      slidesPerGroup={3}
                      freeModeFluid= {true}
                      loop={true}
                      loopFillGroupWithBlank={true}
                      pagination={{
                        clickable: true,
                      }}
                      navigation={true}
                      modules={[Pagination, Navigation]}
                      className="mySwiper"
                    >
                        <SwiperSlide className='Slide'>{this.clientsCard()}</SwiperSlide>
                        <SwiperSlide>{this.clientsCard()}</SwiperSlide>
                        <SwiperSlide>{this.clientsCard()}</SwiperSlide>
                    </Swiper>
                </div>
            </div>
        );
    }
}